<template>
  <div class="shop-container content-wrap" v-loading.fullscreen="loading">
      <swiper-small :list="bannerArr"/>
      <div class="list-wrap">
          <!-- v-for="item in list" :key="item.id" -->
            <div class="list-item"  v-for="item in list" :key="item.id"> 
                <router-link class="pic" tag="a" :to="{name: 'videodetail', params: {videoId: item.id}}">
                    <img :src="item.cover" alt="" class="pic">
                </router-link>
                <div class="title">{{item.title}}</div>
                <div class="bot">
                    <div class="view">{{$t('views')}}：{{item.pv}}</div>
                    <div class="date">{{$t('date')}}：{{item.ctime}}</div>
                </div>
            </div>
      </div>

      <template v-if="list.length>0">
        <Pagination
            :totalPage="totalPage"
            :limit="form.limit"
            @changePage="handleCurrentChange"
        ></Pagination>
    </template>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import SwiperSmall from '@/components/common/SwiperSmall.vue'
import { deepCopy } from "@/utils";
export default {
    components: { Pagination, SwiperSmall },
    data() {
        return {
            list: [],
            form: {
                page: 1,
                limit: 9
            },
            totalPage: 0,
            bannerArr: [],
            loading: false
        }
    },
    watch: {
        $route(to, from) {
            let query = this.$route.query;
            if(query.search_name) {
                delete this.form.id
                this.selectName(query.search_name)
            } else {
                this.form.id =  this.$route.query.id
                this.init(query);
            }
        }
    },
    created() {
        let query = this.$route.query;
        if(this.$route.query.id) {
            this.form.id =  this.$route.query.id
        }
        if(query.search_name) {

            this.selectName(query.search_name)
        } else {
            this.form.id =  this.$route.query.id
            this.init(query);
        }
        this.getBanner()
    },
    methods: {
        // 获取轮播图s
        getBanner() {
            this.$api.slider({
                code: 'pc_video_home_slide'
            }).then(res => {
                if (res.status) {
                    this.bannerArr = res.data.list;
                }
            });
        },
        selectName(name) {
            this.setSearchOptions(name, true);
            this.getList();
        },
        getList() {
            this.loading = true
            this.$api.courseGetlist(this.form).then(res => {
                setTimeout(() =>{
                    this.loading = false
                }, 500)
                if(res.status) {
                    this.list = res.data.list
                    this.totalPage = Math.ceil(res.data.count / this.form.limit) 
                    console.log(this.totalPage, '----', res.data.count , '-----',  this.form.limit)
                }
            })
            
        },
        //设置筛选条件
        setSearchOptions: function(name, clear = false) {

            var sd = this.form;
            this.form = {
                ...this.form,
                where: JSON.stringify({search_name: name})
            } 
            console.log(this.form)

            if (clear) {
                this.list = [];
            }
        },
        handleCurrentChange(v) {
            this.form.page = v
            this.init()
            this.scrollToTop()
        },
        scrollToTop() {
            document.body.scrollTop = document.documentElement.scrollTop = 0
        },
        init() {
            this.loading = true
            this.$api.getcourselist(this.form).then(res => {
                setTimeout(() =>{
                    this.loading = false
                }, 500)
                if(res.status) {
                    this.list = res.data.list[0].course.list
                    this.totalPage = Math.ceil(res.data.list[0].course.count / this.form.limit) 
                    console.log(this.totalPage, '----', res.data.list[0].course.count , '-----',  this.form.limit)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.content-wrap {
    background: #ffffff;
    .list-wrap {
        width: 1226px;
        margin: 0 auto;
        padding: 20px 12px;
        display: flex;
        flex-wrap: wrap;
        .list-item {
            padding: 11px;
            width: 370px;
            background: #fff;
            border: 1px solid #e5e5e5;
            transition: all 0.2s linear 0s;
            box-shadow: 2px 2px 4px #e3e3e3;
            position: relative;
            margin-bottom: 12px;
            margin-left: 12px;
            &:nth-child(3n + 1 ) {
                margin-left: 0;
            }
            &:hover {
                box-shadow: 0 15px 20px rgba(0,0,0,0.1);
            }
            .pic {
                width: 370px;
                height: 216px;
            }
            .title {
                line-height: 40px;
                @include no-wrap();
            }
            .bot {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
        }
    }
}

</style>

<style lang="scss">
.page-box .el-pagination {
    padding-bottom: 20px;
}
</style>